import React from 'react'

const MonthlyField=(props)=>{
    return (
       <>
       <label className="active" htmlFor="monthDate">Month</label>
        <div className="input-field col s6">
        <input type="month" placeholder="2020-01" onChange={props.handleChange} id="monthDate" required pattern="[0-9]{4}-[0-9]{2}" />
        </div>
        </>
    )
}

export default MonthlyField
